<template>
  <form
    v-if="isValidObject(data)"
    class="login__form form--custom"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <h2
      v-if="data.companyName"
      v-html="$t(`${namespace}.title`).replace('[COMPANY_NAME]', data.companyName)"
      class="login__title"
    />

    <p v-html="$t(`${namespace}.text`)" class="login__text" />

    <div>
      <label>{{ $t(`${namespace}.fieldEmployeeLabel`) }}</label>
      <v-text-field
        v-model="form.name"
        :name="$t(`${namespace}.fieldEmployeeName`)"
        :placeholder="$t(`${namespace}.fieldEmployeePlaceholder`)"
        :disabled="submitted"
        v-validate="{ required: true }"
        :error-messages="errors.collect($t(`${namespace}.fieldEmployeeName`))"
        :data-vv-name="$t(`${namespace}.fieldEmployeeName`)"
        required
        flat
        outline
        solo
      />

      <label>{{ $t(`${namespace}.fieldCellNumberLabel`) }}</label>
      <v-text-field
        v-model="form.phoneNumber"
        :name="$t(`${namespace}.fieldCellNumberName`)"
        :placeholder="$t(`${namespace}.fieldCellNumberPlaceholder`)"
        :disabled="submitted"
        v-validate="{
          required: true,
          min: 15,
          max: 15
        }"
        :error-messages="errors.collect($t(`${namespace}.fieldCellNumberName`))"
        :data-vv-name="$t(`${namespace}.fieldCellNumberName`)"
        required
        flat
        outline
        solo
        maxlength="15"
        @input="setPhoneMask($event, 'phone')"
      />

      <label>{{ $t(`${namespace}.fieldDocumentLabel`) }}</label>
      <v-text-field
        v-model="form.document"
        :name="$t(`${namespace}.fieldDocumentName`)"
        :placeholder="$t(`${namespace}.fieldDocumentPlaceholder`)"
        type="tel"
        mask="###.###.###-##"
        :disabled="submitted"
        v-validate="{ cpf: true }"
        :error-messages="errors.collect($t(`${namespace}.fieldDocumentName`))"
        :data-vv-name="$t(`${namespace}.fieldDocumentName`)"
        required
        flat
        outline
        solo
      />
    </div>

    <v-layout align-center justify-center row fill-height>
      <a
        href="#"
        class="text--link accent--text"
        @click.prevent="$router.push({ name: 'Login' })"
      >
        {{ $t('Common.cancel') }}
      </a>

      <v-spacer />

      <v-btn
        type="submit"
        color="warning--gradient"
        :disabled="submitted"
        :loading="submitted"
        class="mx-0"
        round
        depressed
        large
      >
        {{ $t(`${namespace}.buttonLabel`) }}
      </v-btn>
    </v-layout>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { masks } from 'utils/masks'
import { isObject } from 'utils/functions'
import validator from 'utils/validator'

export default {
  name: 'Form',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    routeParams () {
      const { employeeId = null, token = null } = this.$route.params
      return {
        employeeId: employeeId ? Number(employeeId) : null,
        token
      }
    }
  },
  data () {
    return {
      namespace: 'Views.FirstAccessPage.form',
      submitted: false,
      form: {
        name: null,
        phoneNumber: null,
        document: null
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    setData () {
      if (this.isValidObject(this.data)) {
        const { name = null, companyName = null } = this.data
        this.form = {
          name,
          companyName
        }
      }
    },

    setPhoneMask (val, mask) {
      if (val && mask) {
        this.form.phoneNumber = masks[mask](val)
      }
    },

    async handleSubmit () {
      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          this.submitted = true

          const { employeeId, token: firstAccessToken } = this.routeParams
          const { name, phoneNumber, document } = this.form
          const data = {
            name,
            phoneNumber: phoneNumber.replace(/\D/g, ''),
            document: document.replace(/\D/g, '')
          }

          const { data: res } = await this.$apiService.setEmployeeDataFirstAccess(employeeId, {
            ...data,
            firstAccessToken
          })

          if (!res || res.status !== 'success') {
            throw new Error()
          }

          this.$emit('toogleContainer', data)
        }
      } catch (err) {
        console.log('Error', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorAlert`)
        })
      }

      this.submitted = false
    }
  },
  created () {
    this.$validator.extend('cpf', (value) => validator.cpf(value))
  },
  mounted () {
    this.setData()
  }
}
</script>
